
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import { readAdminProjects, readMyProjects } from "@/store/project/getters";
import {
  dispatchCreateProjProjects,
  dispatchDeleteProject,
  dispatchGetMyProjects,
  dispatchGetProjects,
} from "@/store/project/actions";
import { dispatchUpdateMyLastProject } from "@/store/main/actions";
import {
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  unique_json,
} from "@/utils";
import { ElMessage } from "element-plus";
import { readUserProfile } from "@/store/main/getters";

@Options({
  components: {},
})
export default class ProjectHall extends Vue {
  public activeName = "my_project";
  public dialogVisible = false;
  public notification = "";
  public admins = [];
  public serch = "";
  public localProject = Number(getLocalProject());
  public formInline = {
    project_key: "",
    project_name: "",
    pkg_name: "",
    b_invite: false,
    imageUrl: "",
    ios_pkg_name: "",
  };
  public async mounted() {
    await dispatchGetProjects(store, { project: this.localProject });
    await dispatchGetMyProjects(store);
  }

  // 获取所有项目
  public get all_projects() {
    const project: any[] = readAdminProjects(store);
    return project;
  }

  // 获取我的项目
  public get my_projects() {
    const projects: any[] = readMyProjects(store);
    for (let project of projects) {
      project.label = project.project.project_name;
      project.value = project.project.id;
    }
    return unique_json(projects, "value");
  }

  // 进入项目,跳转到任务配置页面
  public enterProject(project: any) {
    const response_data = dispatchUpdateMyLastProject(store, {
      last_visit_project: Number(project.id),
    });
    response_data.then((value) => {
      if (value) {
        this.dialogVisible = true;
        this.admins = value.data;
        this.notification = value.message;
      } else {
        saveLocalProject(String(project.id));
        saveLocalStorageProject(String(project.id));
        this.$router.push({
          path: "/project_overview",
        });
      }
    });
  }

  public formData: any = new FormData();

  public async ploadImage(param: any) {
    this.formData.append("file", param.file);
  }
  public new_all_projects = [];
  public new_my_projects = [];
  public serchChange() {
    if (this.activeName === "all_project") {
      this.new_all_projects = this.all_projects.filter((item) => {
        return item.project_name
          .toUpperCase()
          .includes(this.serch.toUpperCase());
      });

      return this.new_all_projects;
    }
    if (this.activeName === "my_project") {
      this.new_my_projects = this.my_projects.filter((item) => {
        return item.project_name
          .toUpperCase()
          .includes(this.serch.toUpperCase());
      });

      return this.new_my_projects;
    }
  }

  // 操作按钮
  public async editOption(type: string) {
    this.serch = "";
    this.new_all_projects = [];
    this.new_my_projects = [];
    if (type === "no") {
      this.formInline = {
        project_key: "",
        project_name: "",
        pkg_name: "",
        b_invite: false,
        imageUrl: "",
        ios_pkg_name: "",
      };
    } else {
      this.formData.append("project", this.localProject);
      this.formData.append("project_key", this.formInline.project_key);
      this.formData.append("project_name", this.formInline.project_name);
      this.formData.append("pkg_name", this.formInline.pkg_name);
      this.formData.append("b_invite", this.formInline.b_invite ? 1 : 0);
      this.formData.append("ios_pkg_name", this.formInline.ios_pkg_name);
      const formInlineArray: any[] = [];
      for (const key in this.formInline) {
        if (this.formInline[key] === "") {
          formInlineArray.push(" " + key + " ");
        }
      }
      if (formInlineArray.length !== 0) {
        alert("缺失：" + formInlineArray);
      } else {
        await dispatchCreateProjProjects(store, this.formData);
        ElMessage({
          message: "注册完成",
          showClose: true,
        });
      }
    }
    await dispatchGetProjects(store, { project: this.localProject });
  }

  //获取路径
  public handleAvatarSuccess(res: any, file: any) {
    this.formInline.imageUrl = URL.createObjectURL(file.raw);
  }

  // 判断是否是管理员
  public get get_is_super() {
    return readUserProfile(store)?.is_super;
  }

  // 删除项目
  public async DeleteProject(project: any) {
    await dispatchDeleteProject(store, { id: project.id });
  }
}
